/**
 * Ask Hobbes History API service for fetching and managing
 * persisted conversation history.
 */

import apiClient from './client';
import type { ApiResponse } from './client';
import type { OrgAskEvidenceItem } from './orgAsk';

export interface AskHobbesHistoryItem {
  id: string;
  organization_id: string;
  user_id: string;
  prompt: string;
  response_content?: string | null;
  evidence?: OrgAskEvidenceItem[] | null;
  created_at: string;
}

export interface AskHobbesHistoryListResponse {
  items: AskHobbesHistoryItem[];
  total: number;
}

class AskHobbesHistoryService {
  /**
   * Fetch paginated Ask Hobbes conversation history for an organization.
   */
  async getHistory(
    organizationId: string,
    options?: { limit?: number; offset?: number },
  ): Promise<ApiResponse<AskHobbesHistoryListResponse>> {
    return apiClient.get<AskHobbesHistoryListResponse>(
      '/api/session-analytics/org/ask-history',
      {
        organizationId,
        limit: options?.limit ?? 50,
        offset: options?.offset ?? 0,
      },
    );
  }

  /**
   * Delete a single history entry.
   */
  async deleteEntry(entryId: string): Promise<ApiResponse<{ ok: boolean }>> {
    return apiClient.delete<{ ok: boolean }>(
      `/api/session-analytics/org/ask-history/${entryId}`,
    );
  }
}

const askHobbesHistoryService = new AskHobbesHistoryService();
export default askHobbesHistoryService;
